import { render, staticRenderFns } from "./PlanningBoard.vue?vue&type=template&id=160629ac&"
import script from "./PlanningBoard.vue?vue&type=script&lang=js&"
export * from "./PlanningBoard.vue?vue&type=script&lang=js&"
import style0 from "./PlanningBoard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports